import {
  Breadcrumbs,
  Button,
  Inline,
  Stack,
  Typography,
  useViewport,
} from '@omnipresentgroup/design-system';
import { useClientSetupStatus } from '@omnipresentgroup/domains';
import { TimeOffs } from '@omnipresentgroup/features';
import { TimeOffEditingMethod } from '@omnipresentgroup/types';
import { useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { EmployeeSelector } from '../../components';
import { useManagerUser } from '../../hooks';
import { TimeOffsCutOffNotification, UploadTimeOffsModal } from './components';

const PAGE_TITLE = 'Time off';

export const TimeOffsPage = () => {
  const { companyId } = useManagerUser();
  const [modalOpen, setModalOpen] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const { data: clientSetupStatus } = useClientSetupStatus();

  const employeeId = new URLSearchParams(location.search).get(
    'employeeId',
  ) as string;

  const Filters = () => {
    const { isPhone, isTablet } = useViewport();

    const isStacked = useMemo(() => isPhone || isTablet, [isPhone, isTablet]);

    return (
      <Inline maxW={isStacked ? undefined : 400} w="stretch" stretch={1}>
        <EmployeeSelector label="Employee" />
      </Inline>
    );
  };

  return (
    <>
      <Stack gap="16">
        <Breadcrumbs
          crumbs={[
            {
              id: 'home',
              onClick: () => navigate('/'),
              title: 'Home',
            },
            {
              active: true,
              id: 'time-offs',
              title: 'Time off',
            },
          ]}
        />
        <Inline minH={40} align="center" justify="space-between">
          <Typography as="h3" hideParagraphSpacing size="24" weight="medium">
            {PAGE_TITLE}
          </Typography>
          {clientSetupStatus?.timeOffEditingMethod ===
            TimeOffEditingMethod.UPLOAD && (
            <Button
              key="upload-time-offs"
              onClick={() => {
                setModalOpen(true);
              }}
            >
              Upload time off
            </Button>
          )}
        </Inline>
      </Stack>
      <TimeOffsCutOffNotification />
      <TimeOffs
        companyId={employeeId ? undefined : companyId}
        employeeId={employeeId}
        columnVisibility={{
          employeeName: true,
          leaveType: true,
          startDate: true,
          firstDayAfternoonOnly: true,
          endDate: true,
          lastDayMorningOnly: true,
          status: true,
          employeeNote: true,
          actions: true,
        }}
        columnOrderOverride={[
          'employeeName',
          'startDate',
          'firstDayAfternoonOnly',
          'endDate',
          'lastDayMorningOnly',
          'leaveType',
          'employeeNote',
          'status',
          'actions',
        ]}
        filterSection={<Filters />}
      />
      {modalOpen && (
        <UploadTimeOffsModal
          modalProps={{
            open: modalOpen,
          }}
          handleClose={() => {
            setModalOpen(false);
          }}
        />
      )}
    </>
  );
};
